<template>

    <span>
        <span v-if="showValue1">
            {{value1}}
        </span>
        <span v-if="Number(value2) < (Number(value1) + deviationC) && Number(value2) > (Number(value1) - deviationC)">
            <font-awesome-icon icon="check" style="color: green"></font-awesome-icon>
        </span>
        <span v-else-if="invert ? (Number(value2) < Number(value1)) : (Number(value2) > Number(value1))">
            <!--{{ Number(value2) > Number(value1)? "true" : "false" }}-->
            <font-awesome-icon icon="caret-up" style="color:orange"></font-awesome-icon>
        </span>
        <span v-else>
            <font-awesome-icon icon="caret-down" style="color:red"></font-awesome-icon>
        </span>
        <span v-if="showValue2">{{value2}}</span>
    </span>
</template>

<script>
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
    name: "br-caret-value",
    components: {
        FontAwesomeIcon,
    },
    props: {
        value1: { required: true },
        value2: { required: true },
        deviation: { required: false, default: 0 },
        showValue1: { required: false, default: true},
        showValue2: { required: false, default: false },
        invert: { required: false, default: false },
    },
    data() {
        return {
        }
    },
    computed: {
        deviationC : {
            get: function() {
                if( _.isNumber(this.deviation) ) {
                    //console.log("deviation is number: " + this.deviation + " " + this.value1 + " " + this.value2);
                    return Number(this.deviation);
                }
                else if( _.includes(this.deviation, "%")) {
                    let temp =  this.value1 * (Number( this.deviation.replace("%","") ) / 100)
                    //console.log("deviation is a percent: " + temp);
                    return temp;
                }
                else {
                    //console.error("Invalid deviation amount: " + this.deviation);
                    return 0;
                }
            }
        }
    },
    created() {
    },
    methods: {
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BRCaretValue.vue